<template>
    <div>
        <p class="title">申请人1</p>
        <van-cell-group>

            <van-field readonly required clickable label="申请人类型" v-model="sqrlx" placeholder="请选择"
                       @click="showSQRLX = true" input-align="right" is-link/>
            <van-popup v-model="showSQRLX" position="bottom">
                <van-picker show-toolbar :columns="sqrlxList" value-key="name" @cancel="showSQRLX = false"
                            @confirm="onSQRLX"/>
            </van-popup>

            <van-field required readonly label="姓名" placeholder="请输入申请人姓名" v-model="userInfo.sqr1_xm"
                       input-align="right"/>
            <van-field required readonly clickable label="性别" v-model="userInfo.xbmc" placeholder="请选择"
                       @click="showPickerSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerSex" position="bottom">
                <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex = false"
                            @confirm="onConfirmSex"/>
            </van-popup>
            <van-field required readonly clickable label="出生日期" v-model="userInfo.sqr1_csrq" placeholder="请选择"
                       @click="showPickerBirthDate = true" input-align="right" is-link/>
            <van-popup v-model="showPickerBirthDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                     @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>
            </van-popup>
            <van-field required readonly v-model="userInfo.sqr1_gmsfhm" clearable label="公民身份证号" placeholder="请输入身份证号"
                       input-align="right"/>
            <van-field required label="联系电话" placeholder="请输入联系电话" v-model="userInfo.sqr1_lxdh"
                       input-align="right"/>
            <!--户籍地址-->
            <van-field v-model="userInfo.hjdz1" label="户籍地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerHJProvince = true"/>
            <van-popup v-model="showPickerHJProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title"
                            @cancel="showPickerHJProvince = false"
                            @confirm="onConfirmHJProvince"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerHJCity = true" v-if="HJCityShow"/>
            <van-popup v-model="showPickerHJCity" position="bottom">
                <van-picker :columns="cityHJList" show-toolbar value-key="title" @cancel="showPickerHJCity = false"
                            @confirm="onConfirmHJCity"/>
            </van-popup>
            <van-field v-model="userInfo.hjdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerHJArea = true" v-if="HJAreaShow"/>
            <van-popup v-model="showPickerHJArea" position="bottom">
                <van-picker :columns="areaHJList" show-toolbar value-key="title" @cancel="showPickerHJArea = false"
                            @confirm="onConfirmHJArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="userInfo.hjdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="所属派出所:" type="textarea" required v-model="userInfo.sqr1_sspcs"
                       placeholder="请输入所属派出所" rows="1" autosize clearable/>
            <van-field required clickable label="与拟变更人关系" v-model="userInfo.relationName" placeholder="请选择"
                       @click="showPickerRelation = true" input-align="right" is-link/>
            <van-popup v-model="showPickerRelation" position="bottom">
                <van-picker show-toolbar :columns="relationList" value-key="title" @cancel="showPickerRelation = false"
                            @confirm="onConfirmRelation"/>
            </van-popup>
            <!--用户2-->
        </van-cell-group>
        <div v-if="xm2Show">
            <p class="title">申请人2</p>
            <van-cell-group>
                <van-field required label="姓名" :placeholder="xmTips" v-model="userInfo.sqr2_xm"
                           input-align="right"/>
                <van-field required readonly clickable label="性别" v-model="userInfo.xbmc2" placeholder="请选择"
                           @click="showPickerSex2 = true" input-align="right" is-link/>
                <van-popup v-model="showPickerSex2" position="bottom">
                    <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex2 = false"
                                @confirm="onConfirmSex2"/>
                </van-popup>
                <van-field required readonly clickable label="出生日期" v-model="userInfo.sqr2_csrq" placeholder="请选择"
                           @click="showPickerBirthDate2 = true" input-align="right" is-link/>
                <van-popup v-model="showPickerBirthDate2" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                         @cancel="showPickerBirthDate2 = false" @confirm="onConfirmBirthdayDate2"/>
                </van-popup>
                <van-field required v-model="userInfo.sqr2_gmsfhm" clearable label="公民身份证号" placeholder="请输入身份证号"
                           input-align="right"/>
                <van-field required label="联系电话" placeholder="请输入联系电话" v-model="userInfo.sqr2_lxdh"
                           input-align="right"/>
                <van-field v-model="userInfo.nlhdz1" label="户籍地址:" placeholder="请选择省份" is-link required readonly
                           input-align="right"
                           @click="showPickerLHProvince = true"/>
                <van-popup v-model="showPickerLHProvince" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showPickerLHProvince = false"
                                @confirm="onConfirmLHProvince"/>
                </van-popup>
                <van-field v-model="userInfo.nlhdz2" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showPickerLHCity = true" v-if="LHCityShow"/>
                <van-popup v-model="showPickerLHCity" position="bottom">
                    <van-picker :columns="cityLHList" show-toolbar value-key="title" @cancel="showPickerLHCity = false"
                                @confirm="onConfirmLHCity"/>
                </van-popup>
                <van-field v-model="userInfo.nlhdz3" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showPickerLHArea = true" v-if="LHAreaShow"/>
                <van-popup v-model="showPickerLHArea" position="bottom">
                    <van-picker :columns="areaLHList" show-toolbar value-key="title" @cancel="showPickerLHArea = false"
                                @confirm="onConfirmLHArea"/>
                </van-popup>
                <van-field input-align="right" type="textarea" v-model="userInfo.nlhdzxxdz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
                <van-field input-align="right" label="所属派出所:" type="textarea" required v-model="userInfo.sqr2_sspcs"
                           placeholder="请输入所属派出所" rows="1" autosize clearable/>
                <van-field required clickable label="与拟变更人关系" v-model="userInfo.relationName2" placeholder="请选择"
                           @click="showPickerRelation2 = true" input-align="right" is-link/>
                <van-popup v-model="showPickerRelation2" position="bottom">
                    <van-picker show-toolbar :columns="relationList" value-key="title" @cancel="showPickerRelation2 = false"
                                @confirm="onConfirmRelation2"/>
                </van-popup>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
  import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
  import { dateToString } from '@/utils/time'
  import { baseApiMap } from '@/api/base'
  import { matterApiMap } from '@/api/matter'
  import { idCardRegex, phoneRegex } from '@/utils/regex'
  import { forEachObj } from '@/utils/check'

  export default {
    components: {
      [Button.name]: Button,
      [Toast.name]: Toast,
      [CellGroup.name]: CellGroup,
      [Field.name]: Field,
      [Dialog.name]: Dialog,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    props: {
      applicationInfo: {
        type: Object,
        default: () => ({})
      },
    },
    watch: {
      sqrlxId(val) {
        if (val === 0) {
          this.xm2Show = true
          this.xmTips = '请输入母亲姓名'
          this.getProvinceData()
          this.userInfo.xbmc = '男'
          this.userInfo.sqr1_xb = '1'
          this.userInfo.xbmc2 = '女'
          this.userInfo.sqr2_xb = '2'
          this.userInfo.relationName = '父亲'
          this.userInfo.sqr1_ynbgrgx = '51'
          this.userInfo.relationName2 = '母亲'
          this.userInfo.sqr2_ynbgrgx = '52'
          this.$emit('nbgrInfoChange',false)
        } else if (val === 1) {
          this.xm2Show = true
          this.xmTips = '请输入父亲姓名'
          this.getProvinceData()
          this.userInfo.xbmc = '女'
          this.userInfo.sqr1_xb = '2'
          this.userInfo.xbmc2 = '男'
          this.userInfo.sqr2_xb = '1'
          this.userInfo.relationName = '母亲'
          this.userInfo.sqr1_ynbgrgx = '52'
          this.userInfo.relationName2 = '父亲'
          this.userInfo.sqr2_ynbgrgx = '51'
          this.$emit('nbgrInfoChange',false)
        } else {
          this.xm2Show = false
          this.xmTips = ''
          this.provinceList= [{title: '湖北省', val: '420000'}]
          this.userInfo.xbmc = ''
          this.userInfo.relationName = '本人'
          this.userInfo.sqr1_ynbgrgx = '01'
          this.$emit('nbgrInfoChange',true)
        }
      },
    },
    data() {
      return {
        xm2Show: true,
        xmTips: '请输入母亲姓名',
        sqrlx: '未成年人父亲申请',
        sqrlxId: 0,
        userInfo: {
          sqr1_xm: this.$cookie.getUser().realName,
          xbmc: '男',
          sqr1_xb: '1',
          sqr1_csrq: '',
          sqr1_gmsfhm: this.$cookie.getUser().idNum,
          hjdz1: '',
          hjdz2: '',
          hjdz3: '',
          hjdzxxdz: '',
          sqr1_sspcs: '',
          sqr1_lxdh: this.$cookie.getUser().telephone,
          sqr1_ynbgrgx: '',
          sqr2_ynbgrgx: '',
          relationName: '父亲',
          sqr1_ynbgrgx: '51',
          relationName2: '母亲',
          sqr2_ynbgrgx: '52',
          sqr2_xm: '',
          xbmc2: '女',
          sqr2_xb: '2',
          sqr2_csrq: '',
          sqr2_gmsfhm: '',
          sqr2_lxdh: '',
          sqr2_sspcs: '',
          nlhdz1: '',
          nlhdz2: '',
          nlhdz3: '',
          matName: '',
          ydj: '',
          ndj: ''
        },
        sexList: [],
        relationList: [],
        showPickerSex: false, // 是否显示性别选择框
        showPickerSex2: false, // 是否显示性别选择框
        showPickerRelation: false,
        showPickerRelation2: false,
        showSQRLX: false,
        currentDate: new Date(), // 当前日期
        minDate: new Date(1900, 0, 1), // 最小日期
        maxDate: new Date(), //最大日期
        showPickerBirthDate: false, // 是否显示出生日期选择框
        showPickerBirthDate2: false, // 是否显示出生日期选择框
        provinceList: [], // 省
        cityHJList: [], // 户籍市
        areaHJList: [], // 户籍区县
        showPickerHJProvince: false, // 是否显示户籍省选择框
        HJCityShow: false, // 是否显示户籍市
        HJAreaShow: false, // 是否显示户籍区县
        showPickerHJCity: false, // 是否显示户籍市选择框
        showPickerHJArea: false, // 是否显示户籍区县选择框
        citySJList: [], // 实际居住地市
        areaSJList: [], // 实际居住地区县
        showPickerSJProvince: false, // 是否显示实际居住地省选择框
        SJCityShow: false, // 是否显示实际居住地市
        SJAreaShow: false, // 是否显示实际居住地区县
        showPickerSJCity: false, // 是否显示实际居住地市选择框
        showPickerSJArea: false, // 是否显示实际居住地区县选择框
        showPickernlhdlx: false, // 是否显示拟落户地址类型选择框
        nlhlxList: [{ val: '家庭户', title: '家庭户' }, { val: '单位集体户', title: '单位集体户' },
          { val: '社区公共户', title: '社区公共户' }], // 拟落户地址类型
        sqrlxList: [
          {
            name: '未成年人父亲申请',
            id: 0
          },
          {
            name: '未成年人母亲申请',
            id: 1
          },
          {
            name: '成年人本人申请',
            id: 2
          }
        ],
        cityLHList: [], // 拟落户地址市
        areaLHList: [], // 拟落户地址区县
        showPickerLHProvince: false, // 是否显示拟落户地址省选择框
        LHCityShow: false, // 是否显示拟落户地址市
        LHAreaShow: false, // 是否显示拟落户地址区县
        showPickerLHCity: false, // 是否显示拟落户地址市选择框
        showPickerLHArea: false, // 是否显示拟落户地址区县选择框

      }
    },
    mounted() {
      this.getProvinceData()
      this.getSexList()
      this.getRelation()
    },
    methods: {
      getRelation() {
        this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz_gx_docking`).then(res => {
          this.relationList = res.data.data
        })
      },
      /**
       * 加载性别
       */
      getSexList() {
        this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
          let arr = [];
          if (response.data.succ = true) {
            let arrSex = response.data.data;
            for (let i = 0; i < arrSex.length; i++) {
              arr.push({ "name": arrSex[i].title, "key": arrSex[i].val })
            }
          }
          this.$nextTick(() => {
            this.sexList = arr
          })
        })
      },
      /**
       * 获取省
       */
      async getProvinceData() {
        try {
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.provinceList = arr
        } catch (error) {
          Toast('服务器运行失败')
          console.log(error);
        }
      },
      /**
       * 获取市
       */
      async getHJCityData(value) {
        try {
          this.cityHJList = []
          this.areaHJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.cityHJList = arr
          if (this.cityHJList.length > 0) {
            this.HJCityShow = true
          } else {
            this.HJCityShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 获取地区
       */
      async getHJAreaData(value) {
        try {
          this.areaHJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.areaHJList = arr
          if (this.areaHJList.length > 0) {
            this.HJAreaShow = true
          } else {
            this.HJAreaShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      onSQRLX(value) {
        console.log(value)
        this.sqrlx = value.name
        this.sqrlxId = value.id
        this.showSQRLX = false
      },
      /**
       * 选择性别
       */
      onConfirmSex(value) {
        this.userInfo.xbmc = value.name
        this.userInfo.sqr1_xb = value.key
        this.showPickerSex = false
      },
      onConfirmSex2(value) {
        this.userInfo.xbmc2 = value.name
        this.userInfo.sqr2_xb = value.key
        this.showPickerSex2 = false
      },
      /**
       * 选择关系
       */
      onConfirmRelation(value) {
        console.log(value)
        this.userInfo.relationName = value.title
        this.userInfo.sqr1_ynbgrgx = value.val
        this.showPickerRelation = false
      },
      onConfirmRelation2(value) {
        console.log(value)
        this.userInfo.relationName2 = value.title
        this.userInfo.sqr2_ynbgrgx = value.val
        this.showPickerRelation2 = false
      },
      /**
       * 选择出生日期
       */
      onConfirmBirthdayDate(value) {
        this.userInfo.sqr1_csrq = dateToString(value, "yyyy-MM-dd")
        this.showPickerBirthDate = false
      },
      onConfirmBirthdayDate2(value) {
        this.userInfo.sqr2_csrq = dateToString(value, "yyyy-MM-dd")
        this.showPickerBirthDate2 = false
      },
      /**
       * 选择户籍地址省
       */
      onConfirmHJProvince(value) {
        this.userInfo.hjdz1 = value.title
        this.userInfo.hjdz2 = ''
        this.userInfo.hjdz3 = ''
        this.showPickerHJProvince = false
        this.getHJCityData(value.val)
      },
      /**
       * 选择户籍地址市
       */
      onConfirmHJCity(value) {
        this.showPickerHJCity = false
        this.userInfo.hjdz2 = value.title
        this.userInfo.hjdz3 = ''
        this.getHJAreaData(value.val)
      },
      /**
       * 选择户籍区县
       */
      onConfirmHJArea(value) {
        this.showPickerHJArea = false
        this.userInfo.hjdz3 = value.title
      },
      /**
       * 获取实际居住地址市
       */
      async getSJCityData(value) {
        try {
          this.citySJList = []
          this.areaSJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.citySJList = arr
          if (this.citySJList.length > 0) {
            this.SJCityShow = true
          } else {
            this.SJCityShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 获取实际居住地址区县
       */
      async getSJAreaData(value) {
        try {
          this.areaSJList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.areaSJList = arr
          if (this.areaSJList.length > 0) {
            this.SJAreaShow = true
          } else {
            this.SJAreaShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 选择实际居住地址省
       */
      onConfirmSJProvince(value) {
        this.userInfo.sjjzdz1 = value.title
        this.userInfo.sjjzdz2 = ''
        this.userInfo.sjjzdz3 = ''
        this.showPickerSJProvince = false
        this.getSJCityData(value.val)
      },
      /**
       * 选择实际居住地址市
       */
      onConfirmSJCity(value) {
        this.showPickerSJCity = false
        this.userInfo.sjjzdz2 = value.title
        this.userInfo.sjjzdz3 = ''
        this.getSJAreaData(value.val)
      },
      /**
       * 选择实际居住地址区县
       */
      onConfirmSJArea(value) {
        this.showPickerSJArea = false
        this.userInfo.sjjzdz3 = value.title
      },
      /**
       * 选择拟落户地址类型
       */
      onConfirmLH(value) {
        this.showPickernlhdlx = false
        this.userInfo.nlhdzlx = value.title
      },
      /**
       * 获取拟落户地址市
       */
      async getLHCityData(value) {
        try {
          this.cityLHList = []
          this.areaLHList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.cityLHList = arr
          if (this.cityLHList.length > 0) {
            this.LHCityShow = true
          } else {
            this.LHCityShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 获取拟落户地址区县
       */
      async getLHAreaData(value) {
        try {
          this.areaLHList = []
          const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
          let arr = [];
          if (res.data.succ = true) {
            let d = res.data.data
            for (let i = 0; i < d.length; i++) {
              arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
            }
          }
          this.areaLHList = arr
          if (this.areaLHList.length > 0) {
            this.LHAreaShow = true
          } else {
            this.LHAreaShow = false
          }
        } catch (error) {
          Toast('服务器运行失败');
          console.log(error);
        }
      },
      /**
       * 选择拟落户地址省
       */
      onConfirmLHProvince(value) {
        this.userInfo.nlhdz1 = value.title
        this.userInfo.nlhdz2 = ''
        this.userInfo.nlhdz3 = ''
        this.showPickerLHProvince = false
        this.getLHCityData(value.val)
      },
      /**
       * 选择拟落户地址市
       */
      onConfirmLHCity(value) {
        this.showPickerLHCity = false
        this.userInfo.nlhdz2 = value.title
        this.userInfo.nlhdz3 = ''
        this.getLHAreaData(value.val)
      },
      /**
       * 选择拟落户地址区县
       */
      onConfirmLHArea(value) {
        this.showPickerLHArea = false
        this.userInfo.nlhdz3 = value.title
      },
      /**
       * 校验数据
       */
      validApplicationPersonInfo1() {
        forEachObj(this.userInfo) // 去掉空格
        if (!this.userInfo.sqr1_xm) {
          Toast('请输入申请人姓名')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr1_xb) {
          Toast('请选择申请人性别')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr1_csrq) {
          Toast('请选择申请人出生日期')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!idCardRegex(this.userInfo.sqr1_gmsfhm)) {
          Toast('请输入正确的申请人公民身份证号')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!phoneRegex(this.userInfo.sqr1_lxdh)) {
          Toast('请输入正确的申请人1联系电话')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.hjdz3) {
          Toast('请选择申请人户籍地址')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.hjdzxxdz) {
          Toast('请输入申请人区划内详细地址')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr1_sspcs) {
          Toast('请输入申请人所属派出所')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr1_ynbgrgx) {
          Toast('请选择拟变更人关系')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr2_xm && this.sqrlxId !== 2) {
          Toast('请输入申请人姓名')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr2_xb && this.sqrlxId !== 2) {
          Toast('请选择申请人性别')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr2_csrq && this.sqrlxId !== 2) {
          Toast('请选择申请人出生日期')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!idCardRegex(this.userInfo.sqr2_gmsfhm) && this.sqrlxId !== 2) {
          Toast('请输入正确的申请人身份证号码')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!phoneRegex(this.userInfo.sqr2_lxdh) && this.sqrlxId !== 2) {
          Toast('请输入正确的申请人2联系电话')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.nlhdz3 && this.sqrlxId !== 2) {
          Toast('请选择申请人地址')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.nlhdzxxdz && this.sqrlxId !== 2) {
          Toast('请选择申请人详细地址')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr2_sspcs && this.sqrlxId !== 2) {
          Toast('请选择申请人所属派出所')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        if (!this.userInfo.sqr2_ynbgrgx && this.sqrlxId !== 2) {
          Toast('请选择拟变更人关系')
          this.$emit('getApplicationPersonInfo1', false)
          return
        }
        this.applicationInfo.sqr1_xm = this.userInfo.sqr1_xm
        this.applicationInfo.sqr1_xb = this.userInfo.sqr1_xb
        this.applicationInfo.sqr1_csrq = this.userInfo.sqr1_csrq
        this.applicationInfo.sqr1_gmsfhm = this.userInfo.sqr1_gmsfhm
        this.applicationInfo.sqr1_lxdh = this.userInfo.sqr1_lxdh
        this.applicationInfo.sqr1_hjdz = this.userInfo.hjdz1 + this.userInfo.hjdz2 + this.userInfo.hjdz3 + this.userInfo.hjdzxxdz
        this.applicationInfo.sqr1_sspcs = this.userInfo.sqr1_sspcs
        this.applicationInfo.sqr1_ynbgrgx = this.userInfo.sqr1_ynbgrgx
        this.applicationInfo.sqr2_xm = this.userInfo.sqr2_xm
        this.applicationInfo.sqr2_xb = this.userInfo.sqr2_xb
        this.applicationInfo.sqr2_csrq = this.userInfo.sqr2_csrq
        this.applicationInfo.sqr2_gmsfhm = this.userInfo.sqr2_gmsfhm
        this.applicationInfo.sqr2_lxdh = this.userInfo.sqr2_lxdh
        this.applicationInfo.sqr2_sspcs = this.userInfo.sqr2_sspcs
        this.applicationInfo.sqr2_hjdz = this.userInfo.nlhdz1 + this.userInfo.nlhdz2 + this.userInfo.nlhdz3 + this.userInfo.nlhdzxxdz
        this.applicationInfo.sqr2_ynbgrgx = this.userInfo.sqr2_ynbgrgx
        this.applicationInfo.sqly = ''
        if (this.sqrlxId === 2) {
          this.applicationInfo.sqr2_xm = ''
          this.applicationInfo.sqr2_xb = ''
          this.applicationInfo.sqr2_csrq = ''
          this.applicationInfo.sqr2_gmsfhm = ''
          this.applicationInfo.sqr2_lxdh = ''
          this.applicationInfo.sqr2_sspcs = ''
          this.applicationInfo.sqr2_hjdz = ''
          this.applicationInfo.sqr2_ynbgrgx = ''
        }
        this.$emit('getApplicationPersonInfo1', true)
        return
      }
    }
  }
</script>

<style>
    .van-field__label {
        width: 100px;
    }
</style>
<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
